module.exports = __webpack_public_path__ + "static/media/quieromibarrio5.538b5754.jpg";